import axios from 'axios';
import { ServiceResponse } from '@/OptimusRoutes/interfaces';
import { Sms } from '../entities/sms.entity';

const NOTIFICATION_ROUTE = '/v2/notification';

type NotificationResponse = { success: { result: Record<string, string | unknown> } };
type ShortenLinkResponse = { url: string };

type NotificationServiceType = {
	sendNotification: (values: Sms) => Promise<ServiceResponse<NotificationResponse>>;
	shortenLink: (value: string) => Promise<ServiceResponse<ShortenLinkResponse>>;
};

const sendNotification = async (data: Sms): Promise<ServiceResponse<NotificationResponse>> => {
	const response = await axios.post(`${NOTIFICATION_ROUTE}/sms`, data);

	return response.data;
};

const shortenLink = async (url: string): Promise<ServiceResponse<ShortenLinkResponse>> => {
	const response = await axios.get<ServiceResponse<ShortenLinkResponse>>(`${NOTIFICATION_ROUTE}/shorten-link/${url}`);

	return response.data;
};

const NotificationService: NotificationServiceType = {
	sendNotification,
	shortenLink,
};

export default NotificationService;
